import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { auth } from '@/firebase/config'

const allowedEmail = 'ops_admin@ad168.org'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: 'dashboard', component: Dashboard },
      { path: 'affiliates', component: () => import('../views/Affiliates.vue') },
      { path: 'tickets', component: () => import('../views/Tickets.vue') },
      { path: 'user/:id', component: () => import('../views/UserDetails.vue') },
      { path: 'approve', component: () => import('../views/MembershipApproval.vue') }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard to protect routes
router.beforeEach((to, from, next) => {
  const isPublicRoute = to.path === '/login';

  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();

      const isAuthorized = user?.email === allowedEmail;

      if (!isPublicRoute && !isAuthorized) {
        // If route requires auth and user isn't authorized, redirect to login
        resolve(next('/login'));
      } else if (isPublicRoute && isAuthorized) {
        // If trying to access login while authorized, redirect to dashboard
        resolve(next('/dashboard'));
      } else {
        // Otherwise proceed normally
        resolve(next());
      }
    });
  });
})

export default router